//Added By jaseem 15-05-2026
import moment from "moment";

//Added By jaseem 15-05-2026
export const REPORT_MONTH_OPTIONS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

/** HTML date input value (YYYY-MM-DD); empty if missing/invalid */
export const toDateInputValue = (val) => {
  if (val == null || val === "") return "";
  const m = moment(val);
  return m.isValid() ? m.format("YYYY-MM-DD") : "";
};
